document.addEventListener('DOMContentLoaded', () => {
    const heroSwiper = new Swiper('.top-content_slider', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 4000,
		},
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		}
	});

	const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		loop: true,
		autoHeight: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		autoplay: {
			delay: 8000,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			type: "bullets",
		},
		breakpoints: {
			600: {
				autoHeight: false,
			}
		}
	});

	// Swiper hostory
	const sliderSwiperHistory = new Swiper('.slider-swiper-history', {
		slidesPerView: 1,
		spaceBetween: 15,
		loop: true,
		autoHeight: true,
		centeredSlides: true,
		speed: 200,
		autoplay: {
			delay: 8000
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			1024: {
				slidesPerView: 1.2,
				spaceBetween: 50,
				loop: true
			}
		}
	});

	const gallerySwiper = new Swiper('.gallery-swiper', {
		slidesPerView: 'auto',
		centeredSlides:true,
		loop: true,
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: ".gallery-next",
			prevEl: ".gallery-prev",
		},
		breakpoints: {
			600: {
				spaceBetween: 90,
			}
		}
	});

	const listImgSwiper = new Swiper('.list-img-swiper', {
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
	
	});

	const imgSwiper = new Swiper('.img-swiper', {
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
	});

	const pressSwiper = new Swiper('.press-swiper', {
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
	});
});